import React from "react";
import StarRatingComp from "../StarRatingCom";

export const FeedbackSkill = ({ title, skills }: any) => {
  return (
    <table className="table-fixed w-full mt-2">
      <thead className="text-sm">
        <tr>
          <th className="w-1/2">
            <p className="p-2 flex justify-start text-xs">{title}</p>
          </th>
          <th className="w-1/2">
            <p className="p-2 flex justify-start text-xs">Rating</p>
          </th>
          <th className="w-1/2">
            <p className="p-2 flex justify-start text-xs">Comments</p>
          </th>
        </tr>
      </thead>
      <tbody className="text-gray-400 ">
        {skills.map((x: any, index: number) => {
          return (
            <tr key={index} className="bg-gray-50 border-b-2 border-white ">
              <td>
                <p className="p-2 text-xs text-gray-500">{x?.skill?.name}</p>
              </td>
              <td>
                <div className="p-2 disabled-rating">
                  <StarRatingComp stars={x?.skill_rating || 0} />
                </div>
              </td>
              <td>
                <p className="p-2 text-xs text-gray-500">
                  {x?.experience || "-"}
                </p>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
